import { useNavigate } from "react-router-dom";
import React, { useRef, useState, useEffect } from "react";
import trans from "../assets/Transport.svg";
import asset from "../assets/Asset.svg";
import gate from "../assets/Gate.svg";
import sign from "../assets/Sign.svg";
import dock from "../assets/Dock.svg";
import nr from "../assets/Nr.png";
import bus from "../assets/Bus.png";
import q from "../assets/Q.png";
import tg from "../assets/Tick.png";
import n from "../assets/N.png";
import logo from "../assets/logo.png";
import twit from "../assets/Twit.png";
import down from "../assets/Down.svg";
import right from "../assets/Right.svg";
import icon from "../assets/Icon.png";
import edu from "../assets/Edu.png";
import ware from "../assets/Ware.png";
import tech from "../assets/Tech.png";
import mech from "../assets/Mech.png";
import a1 from "../assets/A1.png";
import a2 from "../assets/A2.png";
import a3 from "../assets/A3.png";
import a4 from "../assets/A4.png";
import a5 from "../assets/A5.png";
import a6 from "../assets/A6.png";
import bg from "../assets/Ba.png";
import bbb from "../assets/BBB.png";
import ios from "../assets/IOS.png";
import { toast, ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import iosgreen from "../assets/IOSgreen.png";
import pc from "../assets/PC.png";
import pcgreen from "../assets/PCgreen.png";
import playStore from "../assets/Playstore.png";
import appStore from "../assets/Appstore.png";
import load from "../assets/Load.png";
import android from "../assets/Android.png";
import o1 from "../assets/O1.png";
import riarr from "../assets/Rightarr.svg";
import mail from "../assets/Mail.png";
import insta from "../assets/Insta.png";
import face from "../assets/Facebook.png";
import youtube from "../assets/Youtube.png";
import link from "../assets/Link.png";
import phone from "../assets/Phone.png";
import ee from "../assets/Email.png";
import trial from "../assets/Trial.png";
import newsgreen from "../assets/Newsgreen.png";
import androidgreen from "../assets/Androidgreen.png";
import o2 from "../assets/O2.png";
import o3 from "../assets/O3.png";
import o4 from "../assets/O4.png";
import o5 from "../assets/O5.png";
import { Link } from "react-router-dom";
import l1 from "../assets/L1.png";
import l2 from "../assets/L2.png";
import l3 from "../assets/L3.png";
import l4 from "../assets/L4.png";
import mech1 from "../assets/Mech1.png";
import mech2 from "../assets/Mech2.png";
import mech3 from "../assets/Mech3.png";
import mech4 from "../assets/Mech4.png";
import cont from "../assets/Cont.svg";
import cont1 from "../assets/Cont1.svg";
import cont2 from "../assets/Cont2.svg";
import cont3 from "../assets/Cont3.svg";
import cont4 from "../assets/Cont4.svg";

const Industries = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState("Industries");
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const handleClick = (item) => {
    setActiveItem(item);

    if (item === "Products") {
      setShowDropdown(!showDropdown);
    } else {
      setShowDropdown(false);
    }

    if (item === "Pricing") {
      navigate("/new");
    }

    if (item === "Home") {
      navigate("/");
    }

    if (item === "Say Hello") {
      navigate("/contact");
    }

    if (item === "Partner") {
      navigate("/part");
    }
  };

  const [scrolledDown, setScrolledDown] = useState(false);

  const imageSources = [
    cont,
    cont1,
    cont2,
    cont3,
    cont4,

    
  ];
  

  


  const complianceData = [
    { icon: o1, title: "General Data Protection" },
    { icon: o2, title: "SOC2 Compliance Report" },
    { icon: o3, title: "Data Processing Agreement" },
    { icon: o4, title: "ISO Certification" },
    { icon: o5, title: "VAPT Compliance" },
  ];
  const policyRoutes = {
    "Terms and Conditions": "/terms",
    "Privacy Policy": "/privacy",
    "Cookie Policy": "/cookies",
    "Copyright Policy": "/copyright",
  };
  const [showDropdown, setShowDropdown] = useState(false);

 const dropdownItems = [
     {
       title: "LOGISTICS OPERATIONS",
       items: [
    {
   icon: gate,
   name: "Gate",
   description: (
     <>
       Helps organizations track and manage
       <br />
       visitors efficiently.
     </>
   ),
 }
 
         // {
         //   icon: dock,
         //   name: "Dock",
         //   description:
         //     "Helps businesses streamline loading, unloading & scheduling.",
         // },
         // {
         //   icon: sign,
         //   name: "Signage",
         //   description:
         //     "Creating, managing & displaying digital content on screens.",
         // },
       ],
     },
     // {
     //   title: "TRACKING SYSTEM",
     //   items: [
     //     // {
     //     //   icon: trans,
     //     //   name: "Transport",
     //     //   description:
     //     //     "Helps users efficiently manage & optimize transportation services.",
     //     // },
     //     // {
     //     //   icon: bus,
     //     //   name: "Vehicle Management",
     //     //   description:
     //     //     "Tracks vehicles, optimizes routes, and automates expenses.",
     //     // },
     //     // {
     //     //   icon: asset,
     //     //   name: "Asset",
     //     //   description:
     //     //     "Helps businesses track, monitor, and manage assets efficiently.",
     //     // },
     //   ],
     // },
     {
       title: "WORKFORCE MANAGEMENT",
       items: [
         {
   icon: q,
   name: "MeetQ",
   description: (
     <>
       Book & manage meeting rooms
       <br />
       with real-time tracking.
     </>
   ),
 }
 
         // {
         //   icon: tg,
         //   name: "TickGo",
         //   description: "Track tasks, log hours, and update statuses.",
         // },
         // {
         //   icon: n,
         //   name: "Nexus",
         //   description: "Manage attendance, tasks, and productivity.",
         // },
       ],
     },
   ];
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [order, setOrder] = useState([0, 1, 2]);
  const scrollCardsRef = useRef([]);


  const items = [
    "Customization and Tailoring",
    "Regulatory Compliance",
    "Efficiency and Productivity",
    "User Experience",
    "Scalability and Growth",
  ];

  const images = [
    { src: edu, label: "Educational Institutes" },
    { src: ware, label: "Warehouse & Manufacturing" },
    { src: tech, label: "Tech Industries" },
  ];
  const ba = `url(${bg})`;

  const scrollTabs = [
    "Tailored Features",
    "Compliance Requirements",
    "Advanced Systems",
    "Customized Solutions",
    "Comprehensive Solutions",
  ];

  const [scrollActiveIndex, setScrollActiveIndex] = useState(0);
  const [scrollActiveTab, setScrollActiveTab] = useState(scrollTabs[0]);
  

  const scrollCardData = [
    {
      title: "Tailored Features",
      description: `By defining, the gate can include industry-specific compliance features such as
guaranteeing adherence to transportation rules, or maintaining conditions for
products.

By customizing content, users can maximize the effectiveness of their signage campaigns.`,
      image: mech,
    },
    {
      title: "Compliance Requirements",
      description: `By identifying the sector served, the gate can provide personalized features and 
functions that are critical to the industry's specific demands.

Customizing the gate based on the industry served guarantees that it process required for smooth operations.`,
      image: mech1,
    },
    {
      title: "Advanced Systems",
      description: `Gate Mawalog ensures that each industry benefits from advanced gate systems 
designed to meet specific needs and stringent requirements.

We delivers advanced gate system solutions tailored to the unique operational 
demands and regulatory standards of each industry we serve.`,
      image: mech2,
    },
    {
      title: "Customized Solutions",
      description: `Office buildings and shopping centers, specialized solutions for manufacturing 
plants, government buildings, and universities.

Comprehensive solutions tailored for office buildings, retail complexes, 
manufacturing facilities, government institutions, and academic campuses.`,
      image: mech3,
    },
    {
      title: "Comprehensive Solutions",
      description: `Solutions across diverse sectors, including commercial properties, residential 
communities, and educational institutions.

Comprehensive solutions tailored to the unique needs of commercial properties,
residential communities, and educational institutions.`,
      image: mech4,
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setOrder((prev) => [prev[1], prev[2], prev[0]]);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "-40% 0px -55% 0px",
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = parseInt(entry.target.getAttribute("data-index"), 10);
          setScrollActiveIndex(index);
          setScrollActiveTab(scrollTabs[index]);
        }
      });
    }, observerOptions);

    scrollCardsRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      scrollCardsRef.current.forEach((el) => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const scrollToCard = (index) => {
    scrollCardsRef.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };


  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.2 }
    );
  
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
  
    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);



   const isMobile = screenWidth <= 768;
    const isTablet = screenWidth > 768 && screenWidth <= 1024;
       const [isMobileOrTablet, setIsMobileOrTablett] = useState(
      typeof window !== "undefined" ? window.innerWidth <= 1024 : false
    );
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobileOrTablett(window.innerWidth <= 1024);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);


      const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
        const [mobileProductsOpen, setMobileProductsOpen] = useState(false);



         const [hoveredIndexxx, setHoveredIndexxx] = useState(0); // start at first item
  const containerReff = useRef(null);
  const [visiblee, setVisiblee] = useState(true); // Assuming visible logic

  useEffect(() => {
    // Auto change index every 2 seconds
    const interval = setInterval(() => {
      setHoveredIndexxx((prevIndex) => (prevIndex + 1) % items.length);
    }, 2000);

    // Cleanup on unmount
    return () => clearInterval(interval);
  }, [items.length]);


  const [activeIndex, setActiveIndex] = useState(0); // one state for both text and image

useEffect(() => {
  const interval = setInterval(() => {
    setActiveIndex((prev) => (prev + 1) % items.length);
  }, 2000);

  return () => clearInterval(interval);
}, [items.length]);





 
 const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

   const canvasRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState(""); // text from API
    const [userCaptcha, setUserCaptcha] = useState("");
  
    /* ------------------------------------------------------------------- API fetch */
    const fetchCaptcha = async () => {
      try {
        const res = await fetch(
          "https://api-uat.mawalog.com/admin/v2/api/website"
        );
        const json = await res.json();
        setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
      } catch (err) {
        console.error("Error fetching captcha:", err);
      }
    };
  
    /* -- fetch once on mount ------------------------------------------------------- */
    useEffect(() => {
      fetchCaptcha();
    }, []);
  
    /* -- redraw every time captchaValue changes ------------------------------------ */
    useEffect(() => {
      if (!data) return; // nothing to paint yet
      const canvas = canvasRef.current;
      if (!canvas) return;
  
      const ctx = canvas.getContext("2d");
      const W = canvas.width;
      const H = canvas.height;
  
      /* ========= clear & background */
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, W, H);
  
      /* ========= random faint bezier curves (extra distortion) */
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * W, Math.random() * H);
        ctx.bezierCurveTo(
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H
        );
        ctx.lineWidth = 1 + Math.random(); // 1-2 px
        ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
        ctx.stroke();
      }
  
      /* ========= characters (uneven) */
      ctx.font = "bold 22px Arial";
      ctx.fillStyle = "#0A3A72";
      const chars = data.toString().split("");
  
      chars.forEach((ch, i) => {
        const angle = (Math.random() - 0.5) * 0.8; // ±23°
        const x = 8 + i * 14 + (Math.random() * 4 - 2);
        const y = 22 + (Math.random() * 6 - 3);
  
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillText(ch, 0, 0);
        ctx.restore();
      });
  
      /* ========= dots */
      for (let i = 0; i < 45; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
        ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
        ctx.fill();
      }
    }, [data]);
  
    /* -- reload button click ------------------------------------------------------- */
    const handleReload = () => {
      fetch("https://api-uat.mawalog.com/admin/v2/api/website")
        .then((response) => response.json())
        .then((json) => {
          setData(json.data.captcha_code);
          setSessionid(json.data.session_id);
          setToken(json.data.token);
        })
        .catch((error) => console.error("Error fetching data:", error));
    };
  
  const handleSubscribe = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );

      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
     setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };


  const location = useLocation();

  // Scroll to the hash section on mount or hash change
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace("#", ""));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);

  return (
    <div>
             <ToastContainer
        position="bottom-right"
        autoClose={3000}
        style={{ bottom: "80px" }}
      />
      {/* <div
              style={{
                position: "fixed",
                bottom: "5%",
                right: "4%",
                zIndex: 9999,
              }}
              className="floating-button-container"
            >
              <button
                style={{
                  padding: 0,
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <img
                  src={icon}
                  alt="button icon"
                  className="floating-button-icon"
                  style={{
                    width: "12vw",
                    height: "12vw",
                    maxWidth: "50px",
                    maxHeight: "50px",
                  }}
                />
              </button>
      
              <style>{`
          .floating-button-container {
            transition: all 0.3s ease;
          }
      
          .floating-button-icon {
            transition: width 0.3s ease, height 0.3s ease;
          }
      
          @media screen and (max-width: 768px) {
            .floating-button-container {
              bottom: 6%;
              right: 5%;
            }
            .floating-button-icon {
              width: 10vw;
              height: 10vw;
              max-width: 45px;
              max-height: 45px;
            }
          }
      
          @media screen and (max-width: 480px) {
            .floating-button-container {
              bottom: 8%;
              right: 6%;
            }
            .floating-button-icon {
              width: 9vw;
              height: 9vw;
              max-width: 40px;
              max-height: 40px;
            }
          }
        `}</style>
            </div> */}

      
          <>
                  <div
            style={{
              fontFamily: "Epilogue",
              lineHeight: "1.4",
              top: 0,
              zIndex: 1000,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: isMobile ? "10px 3%" : "0px 5%",
              backgroundColor: "#fff",
              flexWrap: "wrap",
               borderBottom: "1px solid #ddd",
            }}
          >
          
          <div
            onClick={() => {
              if (window.location.pathname === "/") {
                window.location.reload();
              } else {
                window.location.href = "/";
              }
            }}
            style={{ cursor: "pointer" }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                maxWidth: isMobile ? "120px" : "150px",
                height: "auto",
                marginLeft: isMobile ? "-10px" : "-50px",
              }}
            />
          </div>
          
             
                     {/* Mobile Hamburger Icon */}
                     {isMobile && (
                       <button
                         onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                         style={{ background: "none", border: "none", cursor: "pointer" }}
                       >
                         <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                           <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                         </svg>
                       </button>
                     )}
             
                     {/* Desktop/Tablet Menu */}
                     {!isMobile && (
                       <div
                         style={{
                           display: "flex",
                           alignItems: "center",
                           gap: "8px",
                           flexDirection: "row",
                           width: "auto",
                           backgroundColor: "transparent",
                           padding: "0",
                         }}
                       >
          {["Products", "Partner", "Say Hello"].map((item, index) => (
                  <div
                    key={index}
                    style={{ position: "relative", width: "auto" }}
                    onMouseEnter={() => {
                      setHoveredItem(item);
                      if (item === "Products") setShowDropdown(true);
                    }}
                    onMouseLeave={() => {
                      setHoveredItem(null);
                      if (item === "Products") setShowDropdown(false);
                    }}
                  >
                    <div
                      onClick={() => handleClick(item)}
                      style={{
                        fontSize: "clamp(12px, 2vw, 16px)",
                        cursor: "pointer",
                        fontWeight: "normal",
                        backgroundColor:
                          activeItem === item || hoveredItem === item
                            ? "#EAF3FF"
                            : "transparent",
                        padding: "8px 16px",
                        borderRadius: "20px",
                        transition: "background-color 0.3s",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        justifyContent: "flex-start",
                      }}
                    >
                      {item}
                      {item === "Products" && (
                        <img
                          src={down}
                          alt="Down Arrow"
                          style={{
                            width: "10px",
                            height: "7px",
                            transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.3s",
                          }}
                        />
                      )}
                    </div>
          
                    {item === "Products" && showDropdown && (
                      <div
                        onMouseEnter={() => setShowDropdown(true)}
                        onMouseLeave={() => setShowDropdown(false)}
                        style={{
                          position: "fixed",
                          top: 30,
                          left: "50%",
                          transform: "translateX(-50%)",
                          zIndex: 9999,
                          marginTop: "20px",
                          backgroundColor: "#FFFFFF",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          borderRadius: "24px",
                          overflow: "hidden",
                          width: "min(980px, 90vw)",
                          maxWidth: "100%",
                          padding: "16px",
                          display: "grid",
                          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                          gap: "16px",
                          boxSizing: "border-box",
                        }}
                      >
                        {dropdownItems.map((section, i) => (
                          <div
                            key={i}
                            style={{
                              paddingRight:
                                i < dropdownItems.length - 1 ? "16px" : undefined,
                              borderRight:
                                i < dropdownItems.length - 1
                                  ? "1px solid #E0E0E0"
                                  : "none",
                            }}
                          >
                            <div
                              style={{
                                color: "#666",
                                fontWeight: 600,
                                marginBottom: 12,
                                textTransform: "uppercase",
                                fontSize: 12,
                              }}
                            >
                              {section.title}
                            </div>
          
                            {section.items.map((product, j) => (
                              <div
                                key={j}
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: 10,
                                  padding: "8px",
                                  cursor: "pointer",
                                  marginBottom: 8,
                                  borderRadius: 8,
                                  transition: "background-color 0.3s ease",
                                }}
                                onClick={() => {
                                  if (product.name === "Gate") navigate("/gate");
                                  else if (product.name === "MeetQ") navigate("/meetq");
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = "#F0F8FF";
                                  const name = e.currentTarget.querySelector(
                                    ".product-name"
                                  );
                                  const arrow = e.currentTarget.querySelector(".arrow-icon");
                                  if (name) name.style.color = "#004aad";
                                  if (arrow) {
                                    arrow.style.filter =
                                      "brightness(0) saturate(100%) invert(17%) sepia(99%) saturate(746%) hue-rotate(197deg) brightness(94%) contrast(100%)";
                                    arrow.style.transform = "translateX(4px)";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = "transparent";
                                  const name = e.currentTarget.querySelector(
                                    ".product-name"
                                  );
                                  const arrow = e.currentTarget.querySelector(".arrow-icon");
                                  if (name) name.style.color = "inherit";
                                  if (arrow) {
                                    arrow.style.filter = "none";
                                    arrow.style.transform = "translateX(0)";
                                  }
                                }}
                              >
                                <img
                                  src={product.icon}
                                  alt={product.name}
                                  style={{ width: 20, height: 20 }}
                                />
                                <div>
                                  <div
                                    className="product-name"
                                    style={{
                                      fontWeight: 600,
                                      display: "flex",
                                      alignItems: "center",
                                      transition: "color 0.3s ease",
                                      fontSize: 13,
                                    }}
                                  >
                                    {product.name}
                                    <img
                                      className="arrow-icon"
                                      src={nr}
                                      alt="arrow"
                                      style={{
                                        marginLeft: 4,
                                        width: 16,
                                        height: 16,
                                        transition: "filter 0.3s ease, transform 0.3s ease",
                                      }}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      color: "#666",
                                      fontSize: 12,
                                      textAlign: "left",
                                      lineHeight: 1.4,
                                    }}
                                  >
                                    {product.description}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
          
             
                         <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
                           <button
            onClick={() => window.open("http://app.mawalog.com/login", "_blank")}
            className="login-button"
            style={{
              padding: "10px 20px",
              borderRadius: "20px",
              border: "1px solid #004aad",
              backgroundColor: "#fff",
              color: "#004aad",
              fontWeight: "bold",
              cursor: "pointer",
              fontSize: "16px",
              transition: "background-color 0.3s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
          >
            Login
          </button>
          
                           <button
                             onClick={() => window.open("https://app.mawalog.com/register", "_blank")}
                             className="register-button"
                             style={{
                               padding: "10px 20px",
                               borderRadius: "20px",
                               border: "none",
                               backgroundColor: "#004aad",
                               color: "#fff",
                               fontWeight: "bold",
                               cursor: "pointer",
                               fontSize: "16px",
                               transition: "background-color 0.3s",
                             }}
                             onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                             onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                           >
                             Register
                           </button>
                         </div>
                       </div>
                     )}
                   </div>
             
                   {/* Mobile Menu */}
                   {isMobile && isMobileMenuOpen && (
                     <div
                       style={{
                         position: "fixed",
                         top: 0,
                         left: 0,
                         width: "100%",
                         height: "100%",
                         backgroundColor: "#fff",
                         padding: "20px",
                         overflowY: "auto",
                         zIndex: 1001,
                         boxSizing: "border-box",
                         fontFamily: "Epilogue, sans-serif",
                       }}
                     >
                       {/* Header with Logo and Close Button */}
                       <div
                         style={{
                           display: "flex",
                           justifyContent: "space-between",
                           alignItems: "center",
                           marginBottom: "20px",
                         }}
                       >
                         <Link to="/">
            <img
              src={logo}
              alt="Logo"
              style={{ width: "120px", height: "auto", cursor: "pointer" }}
            />
          </Link>
                         <button
                           onClick={() => setIsMobileMenuOpen(false)}
                           style={{ background: "none", border: "none", cursor: "pointer" }}
                         >
                           <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                             <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                           </svg>
                         </button>
                       </div>
             
                       {/* Navigation Items */}
                       {["Products", "Partner", "Say Hello"].map((item, index) => (
                         <div key={index} style={{ marginBottom: "12px", width: "100%" }}>
                           {item === "Products" ? (
                             <>
                               <div
                                 onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                                 style={{
                                   fontSize: "16px",
                                   cursor: "pointer",
                                   fontWeight: "600",
                                   color: "#004aad",
                                   padding: "12px",
                                   display: "flex",
                                   justifyContent: "center",
                                   alignItems: "center",
                                   borderRadius: "8px",
                                   transition: "background-color 0.3s",
                                   textAlign: "center",
                                 }}
                                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                               >
                                 Products
                                 <img
                                   src={down}
                                   alt="Arrow"
                                   style={{
                                     width: "10px",
                                     height: "7px",
                                     transform: mobileProductsOpen ? "rotate(180deg)" : "rotate(0deg)",
                                     transition: "transform 0.3s",
                                   }}
                                 />
                               </div>
                               {mobileProductsOpen && (
                                 <div
                                   style={{
                                     marginTop: "12px",
                                     padding: "16px",
                                     backgroundColor: "#F9FAFB",
                                     borderRadius: "12px",
                                     display: "flex",
                                     flexDirection: "column",
                                     gap: "16px",
                                     maxWidth: "100%",
                                     overflow: "auto",
                                     boxSizing: "border-box",
                                     justifyContent: "center",
                                     alignItems: "center",
                                     textAlign: "center",
                                   }}
                                 >
                                   {dropdownItems.map((section, i) => (
                                     <div key={i} style={{ marginBottom: "16px", width: "100%", maxWidth: "90%" }}>
                                       <div
                                         style={{
                                           color: "#666",
                                           fontWeight: "600",
                                           textTransform: "uppercase",
                                           fontSize: "12px",
                                           marginBottom: "8px",
                                         }}
                                       >
                                         {section.title}
                                       </div>
                                       {section.items.map((product, j) => (
                                         <div
                                           key={j}
                                           style={{
                                             display: "flex",
                                             flexDirection: "column",
                                             alignItems: "center",
                                             gap: "8px",
                                             padding: "8px",
                                             cursor: "pointer",
                                             borderRadius: "8px",
                                             transition: "background-color 0.3s ease",
                                             maxWidth: "100%",
                                           }}
                                           onClick={() => {
                                             if (product.name === "Gate") navigate("/gate");
                                             else if (product.name === "MeetQ") navigate("/meetq");
                                             setIsMobileMenuOpen(false);
                                           }}
                                           onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = "#F0F8FF";
                                             const name = e.currentTarget.querySelector(".product-name");
                                             name.style.color = "#004aad";
                                           }}
                                           onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = "transparent";
                                             const name = e.currentTarget.querySelector(".product-name");
                                             name.style.color = "inherit";
                                           }}
                                         >
                                           <img src={product.icon} alt={product.name} style={{ width: "20px", height: "20px" }} />
                                           <div style={{ flex: 1, overflow: "hidden" }}>
                                             <div
                                               className="product-name"
                                               style={{
                                                 fontWeight: "600",
                                                 fontSize: "14px",
                                                 transition: "color 0.3s ease",
                                                 whiteSpace: "normal",
                                                 overflow: "hidden",
                                                 textOverflow: "ellipsis",
                                                 textAlign: "center",
                                               }}
                                             >
                                               {product.name}
                                             </div>
                                             <div
                                               style={{
                                                 color: "#666",
                                                 fontSize: "12px",
                                                 lineHeight: "1.4",
                                                 overflowWrap: "break-word",
                                                 textAlign: "center",
                                               }}
                                             >
                                               {product.description}
                                             </div>
                                           </div>
                                         </div>
                                       ))}
                                     </div>
                                   ))}
                                   <a
                                     href="#"
                                     style={{
                                       color: "#004aad",
                                       fontWeight: "600",
                                       fontSize: "14px",
                                       textDecoration: "none",
                                       display: "inline-flex",
                                       alignItems: "center",
                                       padding: "8px",
                                     }}
                                     onClick={() => setIsMobileMenuOpen(false)}
                                   >
                                     Explore all products
                                     <img
                                       src={right}
                                       alt="arrow"
                                       style={{
                                         marginLeft: "4px",
                                         width: "16px",
                                         height: "16px",
                                         verticalAlign: "middle",
                                       }}
                                     />
                                   </a>
                                 </div>
                               )}
                             </>
                           ) : (
                             <div
                               onClick={() => {
                                 handleClick(item);
                                 setIsMobileMenuOpen(false);
                               }}
                               style={{
                                 fontSize: "16px",
                                 cursor: "pointer",
                                 fontWeight: "600",
                                 color: "#004aad",
                                 padding: "12px",
                                 borderRadius: "8px",
                                 transition: "background-color 0.3s",
                                 textAlign: "center",
                               }}
                               onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                               onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                             >
                               {item}
                             </div>
                           )}
                         </div>
                       ))}
             
                       {/* Buttons */}
                       <div
                         style={{
                           display: "flex",
                           flexDirection: "column",
                           gap: "12px",
                           width: "100%",
                           marginTop: "20px",
                         }}
                       >
                         <button
                           onClick={() => {
                             window.location.href = "http://app.mawalog.com/login";
                             setIsMobileMenuOpen(false);
                           }}
                           style={{
                             padding: "8px 16px",
                             borderRadius: "20px",
                             border: "1px solid #004aad",
                             backgroundColor: "#fff",
                             color: "#004aad",
                             fontWeight: "bold",
                             cursor: "pointer",
                             fontSize: "14px",
                             width: "100%",
                             transition: "background-color 0.3s",
                           }}
                           onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
                           onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
                         >
                           Login
                         </button>
                         <button
                           onClick={() => {
                             window.open("https://app.mawalog.com/register", "_blank");
                             setIsMobileMenuOpen(false);
                           }}
                           style={{
                             padding: "8px 16px",
                             borderRadius: "20px",
                             border: "none",
                             backgroundColor: "#004aad",
                             color: "#fff",
                             fontWeight: "bold",
                             cursor: "pointer",
                             fontSize: "14px",
                             width: "100%",
                             transition: "background-color 0.3s",
                           }}
                           onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                           onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                         >
                           Register
                         </button>
                       </div>
                     </div>
                   )}
             
                   {/* Media Queries for Tablet Button Size */}
                   <style>
                     {`
                       @media (min-width: 769px) and (max-width: 1024px) {
                         .login-button, .register-button {
                           padding: 8px 16px !important;
                           font-size: 14px !important;
                         }
                       }
                     `}
                   </style>
                 </>
         
   <div
     style={{
       display: "flex",
       flexWrap: "wrap",
       alignItems: "center",
       justifyContent: "space-between",
       padding: "5px clamp(16px, 4vw, 30px)",
       fontFamily: "sans-serif",
       backgroundColor: "#fff",
       position: "sticky",
       top: 0,
       zIndex: 999,
     }}
   >
     {/* Left: Logo + Nav in one block */}
     <div
       style={{
         display: "flex",
         flexDirection: "row",
         alignItems: "center",
         gap: "clamp(20px, 5vw, 40px)",
         flexWrap: "wrap",
         flexGrow: 1, // fill available space
         minWidth: 0,
       }}
     >
       {/* Logo */}
       <Link to="/gate" style={{ textDecoration: "none" }}>
         <div
           style={{
             display: "flex",
             alignItems: "center",
             gap: "8px",
             cursor: "pointer",
           }}
         >
           <img
             src={gate}
             alt="Gate Logo"
             style={{ width: "32px", height: "32px", marginBottom: "10px" }}
           />
           <span
             style={{
               fontSize: "clamp(24px, 5vw, 30px)",
               fontWeight: 800,
               color: "#1A1A1A",
               whiteSpace: "nowrap",
               marginBottom: "10px",
             }}
           >
             Gate
           </span>
         </div>
       </Link>
   
       {/* Nav Links */}
       <nav
         style={{
           display: "flex",
           gap: "clamp(12px, 4vw, 30px)",
           alignItems: "center",
           flexWrap: "wrap",
           justifyContent: "center",
         }}
       >
        
         {[
  { href: "/industries", text: "Industries Served" },
  { href: "/features", text: "Features" },
  { href: "/price", text: "Pricing" },
  { href: "/faq", text: "FAQ" },
].map(({ href, text }) => (
  <a
    key={text}
    href={href}
    style={{
      fontFamily: "Epilogue",
      fontSize: "clamp(13px, 2.2vw, 16px)",
      fontWeight: 400,
      textDecoration: "none",
      color: text === "Industries Served" ? "#2C8C53" : "#1A1A1A",
      cursor: "pointer",
      lineHeight: 1.4,
      paddingBottom: text === "Industries Served" ? "4px" : "0",
      borderBottom:
        text === "Industries Served" ? "2px solid #2C8C53" : "none",
    }}
  >
    {text}
  </a>
))}

       </nav>
     </div>
   
     {/* Right: Button stays aligned right */}
     <div
       style={{
         flex: "0 0 auto",
         marginLeft: "auto", // pushes it to the right even if wrapped
         marginTop: "10px", // space if it wraps below nav
       }}
     >
       <button
         onClick={() =>
           window.open(
             "https://outlook.office365.com/book/MawalogOne@lenteratechno.onmicrosoft.com/",
             "_blank"
           )
         }
         style={{
           backgroundColor: "#2E8B57",
           color: "#fff",
           padding: "clamp(8px, 1.5vw, 12px) clamp(16px, 6vw, 20px)",
           fontSize: "clamp(12px, 2vw, 14px)",
           fontWeight: 600,
           borderRadius: 9999,
           border: "none",
           cursor: "pointer",
           display: "inline-flex",
           alignItems: "center",
           gap: "6px",
           whiteSpace: "nowrap",
         }}
       >
         Book a Demo
         <img
           src={bbb}
           alt="arrow"
           style={{
             width: "clamp(14px, 3.5vw, 18px)",
             height: "clamp(14px, 3.5vw, 18px)",
           }}
         />
       </button>
   
       
     </div>
   </div>


<>
  <style>{`
    /* ───── Large desktop (≥1280 px) ───── */
    @media (min-width: 1280px) {
      .wrapper {
        gap: 48px !important;           /* a touch more air on very wide screens */
        max-width: 1400px !important;   /* breathe a little wider */
      }
      .image-section div:first-child {  /* hero image grows slightly */
        width: min(320px, 22vw) !important;
      }
    }

    /* ───── Laptop / small desktop (<1280 px) ───── */
    @media (max-width: 1279px) {
      .image-section {
        justify-content: flex-start;    /* keep row flow */
      }
    }

    /* ───── Tablet  (≤1024 px) ───── */
    @media (max-width: 1024px) {
      .image-section {
        justify-content: center !important;
      }
    }

    /* ───── Mobile landscape / large phones (≤768 px) ───── */
    @media (max-width: 768px) {
      .wrapper {
        flex-direction: column !important;
        gap: 30px !important;
      }

      .text-section {
        text-align: center;
        align-items: center;
      }

      .text-section h1 {
        font-size: 28px !important;
      }

      .image-section {
        justify-content: center !important;
      }

      .image-section div {
        width: 100% !important;
        max-width: 280px;
        height: auto !important;
      }

      .image-section img {
        height: auto !important;
      }
    }

    /* ───── Mobile portrait / small phones (≤480 px) ───── */
    @media (max-width: 480px) {
      .text-section h1 {
        font-size: 24px !important;
      }

      .text-section p,
      .text-section div {
        font-size: 14px !important;
      }

      .image-section {
        flex-direction: column !important;
        align-items: center !important;
      }

      .image-section div {
        width: 100% !important;
      }
    }
  `}</style>

  <div
    className="wrapper"
    style={{
      padding: "30px clamp(20px, 5vw, 70px)",
      maxWidth: "clamp(1000px, 80vw, 1300px)",
      margin: "0 auto",
      fontFamily: "Epilogue, sans-serif",
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      gap: "clamp(20px, 4vw, 40px)",
      flexWrap: "wrap",
      justifyContent: "space-between",
    }}
  >
    {/* Left: Text Section */}
    <div className="text-section" style={{ flex: 1, minWidth: "300px" }}>
      <p
        style={{
          color: "#2F8F46",
          fontSize: "clamp(12px, 1.5vw, 14px)",
          fontWeight: "600",
          marginBottom: "12px",
        }}
      >
        Elevating Gate Solutions with Sector Adaptations
      </p>

      <h1
        style={{
          fontSize: "clamp(32px, 3.5vw, 36px)",
          fontWeight: "800",
          color: "#1A1A1A",
          lineHeight: "1.2",
          marginBottom: "20px",
          whiteSpace: "pre-line",
        }}
      >
        Solutions for operational
        <br />
        excellence and <br />
        compliance
      </h1>

      <div
        style={{
          fontSize: "clamp(12px, 1.5vw, 16px)",
          color: "#7D8A9C",
          lineHeight: "1.5",
          fontWeight: "400",
          maxWidth: "600px",
        }}
      >
        Choosing the industry served for a gate allows for the customization of
        features and functionalities to meet the specific needs of that
        industry.
      </div>
    </div>

    {/* Right: Image Section */}
    <div
      className="image-section"
      style={{
        display: "flex",
        gap: "20px",
        flexDirection: "row",
        alignItems: "flex-start",
        flexWrap: "wrap",
        justifyContent: "flex-start",
      }}
    >
      {order.map((index, i) => (
        <div
          key={i}
          style={{
            position: "relative",
            width: i === 0 ? "min(280px, 25vw)" : "min(80px, 7vw)",
            height: "310px",
            overflow: "hidden",
            borderRadius: "30px",
            transition: "all 0.5s ease",
          }}
        >
          <img
            src={images[index].src}
            alt={`Image ${index}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "30px",
            }}
          />

          {i === 0 && (
            <p
              style={{
                position: "absolute",
                bottom: "5px",
                left: "20px",
                color: "white",
                fontWeight: "600",
                fontFamily: "Epilogue",
                fontSize: "16px",
                whiteSpace: "nowrap",
              }}
            >
              {images[index].label}
            </p>
          )}
        </div>
      ))}
    </div>
  </div>
</>



<>
  <style>{`
    /* ❶ Ultra-wide desktop (≥ 1440 px) */
    @media (min-width: 1440px) {
      .sticky-tabs { padding: 22px !important; }
      .tab-list    { gap: 20px !important; }
      .tab-item    { font-size: 16px !important; }
      .scroll-card { width: 80% !important; max-width: 1100px !important; }
    }

    /* ❷ Standard laptop & large tablets (1025 – 1439 px) */
    @media (max-width: 1439px) and (min-width: 1025px) {
      .sticky-tabs { padding: 18px !important; }
      .tab-list    { gap: 14px !important; }
      .scroll-card { width: 88% !important; }
    }

    /* ❸ Tablets (769 – 1024 px) */
    @media (max-width: 1024px) {
      .sticky-tabs { padding: 16px !important; }
      .tab-list    { gap: 12px !important; }
      .scroll-card { width: 94% !important; }

      /* Fix horizontal overflow and image sizing */
      div[style*="maxWidth: 1500px"] {
        overflow-x: hidden !important;
      }

      .scroll-card {
        width: 100% !important;
        max-width: 100% !important;
        padding: 16px !important;
        top: 80px !important; /* less sticky offset for better scroll */
      }

      .scroll-card img {
        max-width: 100% !important;
        height: auto !important;
        margin-left: auto !important;
        margin-right: auto !important;
        display: block !important;
        object-fit: cover;
        border-radius: 30px;
      }

      .sticky-tabs {
        top: 0 !important;
      }
    }

    /* ❹ Large phones / small tablets (481 – 768 px) */
    @media (max-width: 768px) {
      .tab-list        { flex-wrap: wrap !important; }
      .tab-item        { font-size: 13px !important; padding: 5px 10px !important; }

      .scroll-card     { gap: 24px !important; }
      .scroll-card h2  { font-size: 24px !important; text-align: center; }
      .scroll-card p   { font-size: 14px !important; text-align: center; }

      .scroll-card img {
        width: 100% !important;
        max-width: 280px !important; /* reduced max width */
        margin: 0 auto !important;
        display: block;
        height: auto !important;
      }

      /* Fix sticky top offset */
      .scroll-card {
        top: 80px !important;
      }
      .sticky-tabs {
        top: 0 !important;
      }
    }

    /* ❺ Small phones (≤ 480 px) */
    @media (max-width: 480px) {
      .sticky-tabs { padding: 14px !important; top: 0 !important; }
      .tab-item    { font-size: 12px !important; }

      .scroll-card     { padding: 18px !important; gap: 20px !important; }
      .scroll-card h2  { font-size: 20px !important; }
      .scroll-card p   { font-size: 13px !important; }

      .scroll-card img {
        width: 100% !important;
        max-width: 220px !important; /* smaller max width for small phones */
        margin: 0 auto !important;
        display: block;
        height: auto !important;
      }

      /* Fix sticky top offset */
      .scroll-card {
        top: 80px !important;
      }
    }
  `}</style>

  {/* ───── Your original markup (unchanged) ───── */}
  <div>
    {/* Sticky Container */}
    <div
      style={{
        position: "relative",
        maxWidth: "1500px",
        margin: "0 auto",
      }}
    >
      {/* Sticky Tabs */}
      <div
        className="sticky-tabs"
        style={{
          position: "sticky",
          top: "0",
          zIndex: "999",
          backgroundColor: "#fff",
          padding: "20px",
          fontFamily: "Epilogue",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="tab-list"
          style={{
            display: "flex",
            gap: "16px",
            backgroundColor: "#fff",
            padding: "12px 14px",
            border: "1px solid #EBEBEB",
            borderRadius: "40px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "sans-serif",
            transition: "all 0.3s ease",
          }}
        >
          {scrollTabs.map((tab, index) => (
            <div
              key={tab}
              className="tab-item"
              onClick={() => {
                setScrollActiveTab(tab);
                setScrollActiveIndex(index);
                scrollToCard(index);
              }}
              style={{
                backgroundColor:
                  scrollActiveTab === tab ? "#C4FCD8" : "transparent",
                padding: "6px 12px",
                borderRadius: "20px",
                fontWeight: scrollActiveTab === tab ? "600" : "400",
                color: scrollActiveTab === tab ? "#000" : "#4B5563",
                cursor: "pointer",
                transition: "all 0.3s ease",
                fontSize: "14px",
              }}
            >
              {tab}
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Cards */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "30px",
          width: "100%",
        }}
      >
        {scrollCardData.map((card, index) => (
          <div
            key={index}
            data-index={index}
            ref={(el) => (scrollCardsRef.current[index] = el)}
            className="scroll-card"
            style={{
              position: "sticky",
              top: "130px",
              zIndex: scrollActiveIndex === index ? 10 : index,
              transition: "transform 0.5s ease-in-out",
              transform:
                scrollActiveIndex === index
                  ? "translateY(0)"
                  : "translateY(10px)",
              backgroundColor: "#fff",
              borderRadius: "25px",
              padding: "clamp(20px, 4vw, 40px)",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "30px",
              border: "1.5px solid #A3DEB6",
              width: "90%",
              maxWidth: "1000px",
              margin: "0 auto",
              boxSizing: "border-box",
            }}
          >
            <div style={{ flex: "1 1 300px", minWidth: "250px" }}>
              <h2
                style={{
                  fontSize: "clamp(20px, 2.2vw, 28px)",
                  fontWeight: "600",
                  marginBottom: "20px",
                  color: "#212129",
                  fontFamily: "Epilogue",
                }}
              >
                {card.title}
              </h2>
              <p
                style={{
                  fontSize: "clamp(12px, 1.2vw, 14px)",
                  lineHeight: "1.6",
                  color: "#212129",
                  fontFamily: "Epilogue",
                  whiteSpace: "pre-line",
                }}
              >
                {card.description}
              </p>
            </div>
            <div style={{ flexShrink: 0 }}>
              <img
                src={card.image}
                alt={card.title}
                style={{
                  width: "clamp(250px, 30vw, 330px)",
                  height: "auto",
                  borderRadius: "30px",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
</>




  

<>
  {/* ───── Responsive Style for All Devices ───── */}
  <style>
    {`
      /* Desktop & Large Screens (1440px and up) */
      @media (min-width: 1440px) {
        .responsive-title {
          font-size: 16px !important;
          margin-top: 70px !important;
        }
      }

      /* Laptop (1025px to 1439px) */
      @media (min-width: 1025px) and (max-width: 1439px) {
        .responsive-title {
          font-size: 15px !important;
          margin-top: 65px !important;
        }
      }

      /* Tablets (769px to 1024px) */
      @media (max-width: 1024px) and (min-width: 769px) {
        .responsive-title {
          font-size: 13px !important;
          margin-top: 50px !important;
        }
      }

      /* Large Phones / Small Tablets (481px to 768px) */
      @media (max-width: 768px) and (min-width: 481px) {
        .responsive-title {
          font-size: 12.5px !important;
          margin-top: 40px !important;
        }
      }

      /* Small Phones (up to 480px) */
      @media (max-width: 480px) {
        .responsive-title {
          font-size: 12px !important;
          margin-top: 30px !important;
        }
      }
    `}
  </style>

  {/* ───── Your Original Code with Class Added ───── */}
  <div
    className="responsive-title"
    style={{
      fontFamily: "Epilogue",
      fontWeight: "600",
      fontSize: "14px",
      color: "#2C8C53",
      marginTop: "60px",
      textAlign: "center",
    }}
  >
    Industries Served by Gate MAWALOG
  </div>
</>


<>
  <style>
    {`
      /* Desktop & Ultra-wide (≥ 1440px) */
      @media (min-width: 1440px) {
        .responsive-heading {
          font-size: 38px !important;
          margin-top: 35px !important;
          line-height: 1.35 !important;
        }
      }

      /* Laptop (1025px - 1439px) */
      @media (min-width: 1025px) and (max-width: 1439px) {
        .responsive-heading {
          font-size: 32px !important;
          margin-top: 30px !important;
          line-height: 1.3 !important;
        }
      }

      /* Tablets (769px - 1024px) */
      @media (max-width: 1024px) and (min-width: 769px) {
        .responsive-heading {
          font-size: 28px !important;
          margin-top: 25px !important;
          line-height: 1.25 !important;
        }
      }

      /* Large phones / small tablets (481px - 768px) */
      @media (max-width: 768px) and (min-width: 481px) {
        .responsive-heading {
          font-size: 24px !important;
          margin-top: 20px !important;
          line-height: 1.2 !important;
        }
      }

      /* Small phones (≤ 480px) */
      @media (max-width: 480px) {
        .responsive-heading {
          font-size: 20px !important;
          margin-top: 15px !important;
          line-height: 1.15 !important;
        }
      }
    `}
  </style>

  <div
    className="responsive-heading"
    style={{
      fontFamily: "Epilogue",
      fontWeight: "600",
      fontSize: "34px",
      textAlign: "center",
      lineHeight: "1.3",
      marginTop: "30px",
    }}
  >
    Exploring Gate MAWALOG's <br />
    Target Industries
  </div>
</>



<>
  <style>
    {`
      /* Desktop large screens (1440px and above) */
      @media (min-width: 1440px) {
        .responsive-grid {
          gap: 28px !important;
          padding: 50px 25px !important;
          max-width: 1200px !important;
        }
        .responsive-grid > div h3 {
          font-size: 20px !important;
        }
        .responsive-grid > div p {
          font-size: 13px !important;
        }
        .responsive-grid img {
          width: 40px !important;
          height: 40px !important;
          margin-top: -12px !important;
        }
      }

      /* Laptop screens (1025px - 1439px) */
      @media (min-width: 1025px) and (max-width: 1439px) {
        .responsive-grid {
          gap: 24px !important;
          padding: 40px 20px !important;
          max-width: 1100px !important;
        }
        .responsive-grid > div h3 {
          font-size: 18px !important;
        }
        .responsive-grid > div p {
          font-size: 12px !important;
        }
        .responsive-grid img {
          width: 35px !important;
          height: 35px !important;
          margin-top: -10px !important;
        }
      }

      /* Tablet (769px - 1024px) */
      @media (max-width: 1024px) and (min-width: 769px) {
        .responsive-grid {
          gap: 18px !important;
          padding: 30px 15px !important;
          max-width: 900px !important;
        }
        .responsive-grid > div h3 {
          font-size: 16px !important;
        }
        .responsive-grid > div p {
          font-size: 11px !important;
        }
        .responsive-grid img {
          width: 32px !important;
          height: 32px !important;
          margin-top: -9px !important;
        }
      }

      /* Mobile large (481px - 768px) */
      @media (max-width: 768px) and (min-width: 481px) {
        .responsive-grid {
          gap: 14px !important;
          padding: 20px 10px !important;
          max-width: 100% !important;
        }
        .responsive-grid > div h3 {
          font-size: 15px !important;
        }
        .responsive-grid > div p {
          font-size: 10px !important;
        }
        .responsive-grid img {
          width: 30px !important;
          height: 30px !important;
          margin-top: -8px !important;
        }
      }

      /* Mobile small (up to 480px) */
      @media (max-width: 480px) {
        .responsive-grid {
          gap: 12px !important;
          padding: 15px 8px !important;
        }
        .responsive-grid > div h3 {
          font-size: 14px !important;
        }
        .responsive-grid > div p {
          font-size: 9px !important;
        }
        .responsive-grid img {
          width: 28px !important;
          height: 28px !important;
          margin-top: -6px !important;
        }
      }
    `}
  </style>

  <div
    className="responsive-grid"
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(310px, 1fr))",
      gap: "24px",
      padding: "40px 20px",
      maxWidth: "1100px",
      margin: "0 auto",
      fontFamily: "Epilogue",
    }}
  >
    {[
      {
        icon: a1,
        title: "Commercial Properties",
        desc: "Custom gate solutions for offices, malls, warehouses ensure security.",
      },
      {
        icon: a2,
        title: "Residential Communities",
        desc: "Enhanced security through automated gates for communities, complexes, and estates.",
      },
      {
        icon: a3,
        title: "Industrial Facilities",
        desc: "Secure gates for public sector, industrial facilities, such as government, transit, and manufacturing locations.",
      },
      {
        icon: a4,
        title: "Healthcare Facilities",
        desc: "Secure gates for hospitals, research centers, and clinics.",
      },
      {
        icon: a5,
        title: "Hospitality",
        desc: "Improve visitor experiences with effective gate management designed for the hospitality industry.",
      },
      {
        icon: a6,
        title: "Healthcare Facilities",
        desc: "Secure gates for hospitals, research centers, and clinics.",
      },
    ].map((item, idx) => (
      <div
        key={idx}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "90%",
          boxSizing: "border-box",
          border: "1px solid #E5E7EB",
          borderRadius: "12px",
          backgroundColor: "#fff",
          padding: "24px",
          transition: "border-color 0.3s ease, transform 0.3s ease",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = "#2C8C53";
          e.currentTarget.style.transform = "scale(1.03)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = "#E5E7EB";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "16px",
          }}
        >
          <img
            src={item.icon}
            alt={item.title}
            style={{
              width: "35px",
              height: "35px",
              flexShrink: 0,
              marginTop: "-10px",
            }}
          />
          <div>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#111827",
                marginTop: "-10px",
              }}
            >
              {item.title}
            </h3>
            <p
              style={{
                fontSize: "12px",
                color: "#4B5563",
                marginTop: "-10px",
                lineHeight: "1.4",
                margin: 0,
              }}
            >
              {item.desc}
            </p>
          </div>
        </div>
      </div>
    ))}
  </div>
</>





<>
  <style>
    {`
      .responsive-industry-title {
        font-family: "Epilogue";
        font-size: 16px;
        font-weight: 600;
        margin-top: 30px;
        text-align: center;
        color: #2C8C53;
      }

      /* Desktop large screens */
      @media (min-width: 1440px) {
        .responsive-industry-title {
          font-size: 18px !important;
          margin-top: 35px !important;
        }
      }

      /* Laptop screens */
      @media (min-width: 1025px) and (max-width: 1439px) {
        .responsive-industry-title {
          font-size: 16px !important;
          margin-top: 30px !important;
        }
      }

      /* Tablet */
      @media (max-width: 1024px) and (min-width: 769px) {
        .responsive-industry-title {
          font-size: 14px !important;
          margin-top: 25px !important;
        }
      }

      /* Mobile large */
      @media (max-width: 768px) and (min-width: 481px) {
        .responsive-industry-title {
          font-size: 13px !important;
          margin-top: 20px !important;
        }
      }

      /* Small mobile */
      @media (max-width: 480px) {
        .responsive-industry-title {
          font-size: 12px !important;
          margin-top: 15px !important;
        }
      }
    `}
  </style>

  <div className="responsive-industry-title">
    Why industry served matters
  </div>
</>



 <>
  <style>
    {`
      .responsive-significance-title {
        font-family: "Epilogue";
        font-size: 32px;
        font-weight: 600;
        margin-top: 20px;
        text-align: center;
        color: #212129;
        line-height: 1.2;
        padding: 0 16px;
      }

      /* Desktop large */
      @media (min-width: 1440px) {
        .responsive-significance-title {
          font-size: 36px !important;
          padding: 0 20px !important;
        }
      }

      /* Laptop */
      @media (max-width: 1200px) and (min-width: 1025px) {
        .responsive-significance-title {
          font-size: 30px !important;
          padding: 0 14px !important;
        }
      }

      /* Laptop smaller */
      @media (max-width: 1024px) and (min-width: 769px) {
        .responsive-significance-title {
          font-size: 28px !important;
          padding: 0 14px !important;
        }
      }

      /* Tablet */
      @media (max-width: 768px) and (min-width: 481px) {
        .responsive-significance-title {
          font-size: 24px !important;
          padding: 0 12px !important;
        }
      }

      /* Mobile */
      @media (max-width: 480px) {
        .responsive-significance-title {
          font-size: 20px !important;
          padding: 0 8px !important;
        }
      }
    `}
  </style>

  <div className="responsive-significance-title">
    The Significance of Industry <br /> Gate Products
  </div>
</>



<>
  {/* ─── Responsive CSS ─── */}
  <style>
    {`
      .resp-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: flex-start;
        padding: 40px 0;
        gap: 90px;
        font-family: Epilogue;
        box-sizing: border-box;
        overflow-x: hidden;
      }

      .resp-text {
        min-width: 280px;
        max-width: 600px;
        border-left: 2px solid #E5E7EB;
        padding-left: 16px;
        box-sizing: border-box;
        transition: all 0.6s ease-out;
      }

      .resp-image-box {
        flex: 1 1 300px;
        min-width: 260px;
        max-width: 400px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        transition: all 0.6s ease-out;
      }

      .resp-image {
        width: 100%;
        height: auto;
        margin-top: -40px;
        max-height: 350px;
        object-fit: cover;
        border-radius: 12px;
        display: block;
        transition: all 0.3s ease-in-out;
      }

      /* ── Laptop (≤1200 px) ── */
      @media (max-width: 1200px) {
        .resp-container {
          gap: 60px;
          padding: 30px 0;
        }
        .resp-text {
          max-width: 520px;
          padding-left: 14px;
        }
        .resp-image-box {
          max-width: 360px;
        }
      }

      /* ── Tablet (≤768 px) ── */
      @media (max-width: 768px) {
        .resp-container {
          flex-direction: column;
          align-items: center;
          gap: 40px;
          padding: 24px 20px;
        }
        .resp-text {
          border-left: none;
          padding-left: 0;
          max-width: 100%;
          opacity: 1 !important;
          transform: translateX(0) !important;
          min-width: unset;
        }
        .resp-image-box {
          max-width: 100%;
          opacity: 1 !important;
          transform: translateX(0) !important;
          min-width: unset;
        }
        .resp-image {
          margin-top: 0;
          max-height: 320px;
        }
      }

      /* ── Mobile (≤480 px) ── */
      @media (max-width: 480px) {
        .resp-container {
          gap: 30px;
          padding: 18px 12px;
        }
        .resp-text {
          max-width: 100%;
          min-width: unset;
        }
        .resp-image-box {
          max-width: 100%;
          min-width: unset;
        }
        .resp-text p {
          font-size: 13px !important;
        }
        .resp-image {
          max-height: 180px;
          width: 100%;
          margin-top: 0;
        }
      }
    `}
  </style>

  {/* ─── Content ─── */}
  <div ref={containerReff} className="resp-container">
    {/* TEXT SECTION */}
    <div
      className="resp-text"
      style={{
        opacity: visiblee ? 1 : 0,
        transform: visiblee ? "translateX(0)" : "translateX(-60px)",
      }}
    >
      {items.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: "10px",
            borderRadius: "10px",
            marginBottom: "20px",
          }}
        >
          <span style={{ color: "#004BA8", fontSize: "20px" }}>-</span>
          <p
            style={{
              color: activeIndex === index ? "#212129" : "#626F86",
              fontSize: "14px",
              margin: 0,
              padding: activeIndex === index ? "9px 16px" : "4px 8px",
              borderRadius: activeIndex === index ? "100px" : "8px",
              backgroundColor:
                activeIndex === index ? "#CEFFDC" : "transparent",
              transition: "all 0.3s ease",
              cursor: "pointer",
              wordBreak: "break-word",
              maxWidth: "100%",
              lineHeight: "1.5",
            }}
            onMouseEnter={() => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
          >
            {item}
          </p>
        </div>
      ))}
    </div>

    {/* IMAGE SECTION */}
    <div
      className="resp-image-box"
      style={{
        opacity: visiblee ? 1 : 0,
        transform: visiblee ? "translateX(0)" : "translateX(60px)",
      }}
    >
      <img
        src={activeIndex !== null ? imageSources[activeIndex] : cont}
        alt="Customized Solution"
        className="resp-image"
      />
    </div>
  </div>
</>





<>
  {/* ─── Responsive tweaks ─── */}
  <style>
    {`
      .banner-responsive   { padding: 40px 15px; }
      .features-responsive { flex-wrap: wrap; }
      .feature-divider     { width: 1px; height: 150px; background:#eee; }

      /* Laptop (≤1200 px) */
      @media (max-width: 1200px) {
        .banner-responsive { padding: 35px 20px !important; }
        .banner-responsive h2 { font-size: 22px !important; }
        .features-responsive { max-width: 850px !important; }
      }

      /* Tablet (≤768 px) */
      @media (max-width: 768px) {
        .banner-responsive { padding: 30px 18px !important; }
        .banner-responsive h2 { font-size: 20px !important; }
        .features-responsive {
          flex-direction: column !important;
          align-items: center !important;
          max-width: 500px !important; /* restrict width on tablet */
        }
        .feature-divider { display: none !important; }
      }

      /* Mobile (≤480 px) */
      @media (max-width: 480px) {
        .banner-responsive { padding: 25px 14px !important; }
        .banner-responsive p, .banner-responsive h2 { text-align: center !important; }
        .banner-responsive h2 { font-size: 18px !important; }
        .features-responsive {
          max-width: 100% !important; /* full width on mobile */
          padding: 15px !important;
        }
      }
    `}
  </style>

  {/* ─── Your original component ─── */}
  <div
    className="banner-responsive"
    style={{
      backgroundImage: ba,
      backgroundSize: "cover",
      backgroundPosition: "center",
      color: "white",
      padding: "40px 15px", // base padding; overridden by media queries on smaller screens
      borderRadius: "30px",
      fontFamily: "sans-serif",
      textAlign: "center",
      maxWidth: "1000px",
      margin: "0 auto",
    }}
  >
    <p
      style={{
        color: "#A2F0C1",
        fontWeight: "600",
        marginBottom: "8px",
        fontSize: "14px",
      }}
    >
      Industry with Advanced Gate Security Solutions
    </p>

    <h2
      style={{
        fontSize: "24px", // overridden on smaller screens by media queries
        fontWeight: "700",
        marginBottom: "30px",
      }}
    >
      Empowering Gate Security Industry Advancements
    </h2>

    <div
      className="features-responsive"
      style={{
        fontFamily: "Epilogue",
        lineHeight: "1.3",
        backgroundColor: "white",
        color: "#1a1a1a",
        borderRadius: "16px",
        padding: "25px 15px",
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",  // this can be overridden by media query on tablet
        textAlign: "left",
        maxWidth: "900px",
        margin: "0 auto",
      }}
    >
      {[
        {
          img: l1,
          title: "Compliance Check",
          desc: "It checks that the commodities meet MAWALOG’s safety and environmental standards.",
        },
        {
          img: l2,
          title: "Streamlined Process",
          desc: "Once the visitor completes the form and OTP verification, the gate product streamlines the approval process.",
        },
        {
          img: l3,
          title: "Security Measures",
          desc: "To maintain the integrity of MAWALOG operations, the gate product includes sophisticated security measures.",
        },
        {
          img: l4,
          title: "Real Time Tracking",
          desc: "As the visitor approaches, the gate system tracks and monitors MAWALOG items in real time, ensuring secure handling.",
        },
      ].map((item, idx, arr) => (
        <React.Fragment key={idx}>
          <div
            style={{
              flex: "1 1 180px",
              padding: "15px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img
              src={item.img}
              alt={item.title}
              style={{
                width: "40px",
                height: "40px",
                objectFit: "contain",
                marginTop: "20px",
              }}
            />

            <div
              style={{
                fontSize: "15px",
                fontWeight: "700",
                fontFamily: "Epilogue",
                marginTop: "10px",
              }}
            >
              {item.title}
            </div>

            <div
              style={{
                fontSize: "12px",
                color: "#8790A1",
                fontFamily: "Epilogue",
                marginTop: "10px",
              }}
            >
              {item.desc}
            </div>
          </div>

          {/* Divider (hidden on ≤768 px) */}
          {idx < arr.length - 1 && (
            <div className="feature-divider" />
          )}
        </React.Fragment>
      ))}
    </div>

    <p style={{ marginTop: "25px", color: "#97BEA7", fontSize: "12px" }}>
      MAWALOG Gate specific features, compliance checks, increased security
      measures, and real-time tracking <br />
      capabilities, ensuring efficient and secure processing of MAWALOG goods
      from entry to delivery.
    </p>
  </div>
</>




  <div
  style={{
    fontFamily: "Epilogue, sans-serif",
    maxWidth: "1000px",
    margin: "0 auto",
    marginTop: isMobileOrTablet ? "20px" : "50px",
    padding: isMobileOrTablet ? "30px 15px" : "60px 20px",
    border: "1px solid #e0e0e0",
    borderRadius: "16px",
    marginBottom: "60px", // 👈 Prevents touching the next section
  }}
>
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      marginBottom: isMobileOrTablet ? "20px" : "40px",
      gap: isMobileOrTablet ? "10px" : undefined,
    }}
  >
    <div
      style={{
        flex: "1 1 300px",
        fontSize: isMobileOrTablet ? "24px" : "32px",
        fontWeight: "600",
        color: "#1A1A1A",
        marginBottom: isMobileOrTablet ? "10px" : "20px",
      }}
    >
      Download the <br />
      Gate App
    </div>
    <div
      style={{
        flex: "2 1 400px",
        fontSize: isMobileOrTablet ? "12px" : "14px",
        color: "#555",
        lineHeight: "1.6",
      }}
    >
      Stay ahead in evolving business landscapes with agile communication
      strategies that enable quick adaptation, foster resilience, and keep
      your organization aligned, informed, and ready to seize new
      opportunities.
    </div>
  </div>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: isMobileOrTablet ? "10px" : "20px",
    }}
  >
    {/* Android */}
    <a
      href="https://play.google.com/store/apps/details?id=com.mawalog.gate"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit", display: "block" }}
    >
      <div
        style={{
          backgroundColor: isHovered ? "#E6FFEE" : "#f9f9f9",
          borderRadius: "12px",
          padding: isMobileOrTablet ? "12px" : "24px",
          textAlign: "left",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={{ display: "flex", marginBottom: isMobileOrTablet ? "8px" : "16px" }}>
          <img
            src={isHovered ? androidgreen : android}
            alt="android"
            style={{ width: isMobileOrTablet ? "40px" : "50px", height: isMobileOrTablet ? "40px" : "50px" }}
          />
        </div>

        <div style={{ fontSize: isMobileOrTablet ? "11px" : "13px", color: "#808080", marginBottom: "4px" }}>
          Mobile Phone/ Tablet
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "14px" : "18px",
            fontWeight: "600",
            color: isHovered ? "#22A45D" : "#1A1A1A",
            marginBottom: "8px",
            transition: "color 0.3s ease",
          }}
        >
          Android
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "11px" : "13px",
            color: "#555",
            marginBottom: isMobileOrTablet ? "8px" : "16px",
            lineHeight: "1.2",
          }}
        >
          Click on the play store logo for navigate to the download page
        </div>

        <img src={playStore} alt="Google Play" style={{ height: "40px" }} />
      </div>
    </a>

    {/* iOS */}
    <a
      href="https://apps.apple.com/us/app/gate-m/id6477543461"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit", display: "block" }}
    >
      <div
        style={{
          backgroundColor: isHovered1 ? "#E6FFEE" : "#f9f9f9",
          borderRadius: "12px",
          padding: isMobileOrTablet ? "12px" : "24px",
          textAlign: "left",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={() => setIsHovered1(true)}
        onMouseLeave={() => setIsHovered1(false)}
      >
        <div style={{ display: "flex", marginBottom: isMobileOrTablet ? "8px" : "16px" }}>
          <img
            src={isHovered1 ? iosgreen : ios}
            alt="ios"
            style={{ width: isMobileOrTablet ? "40px" : "50px", height: isMobileOrTablet ? "40px" : "50px" }}
          />
        </div>

        <div style={{ fontSize: isMobileOrTablet ? "11px" : "13px", color: "#808080", marginBottom: "4px" }}>
          Mobile Phone/ Tablet
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "14px" : "18px",
            fontWeight: "600",
            color: isHovered1 ? "#22A45D" : "#1A1A1A",
            marginBottom: "8px",
            transition: "color 0.3s ease",
          }}
        >
          iOS
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "11px" : "13px",
            color: "#555",
            marginBottom: isMobileOrTablet ? "8px" : "16px",
            lineHeight: "1.2",
          }}
        >
          Click on the app store logo for navigate to the download page
        </div>

        <img src={appStore} alt="App Store" style={{ height: "40px" }} />
      </div>
    </a>

    {/* PC / Mac */}
    <a
      href="https://s3.ap-south-1.amazonaws.com/gate.mawalog.com/apps/Gate.exe"
      download
      style={{ textDecoration: "none", color: "inherit", display: "block" }}
    >
      <div
        style={{
          backgroundColor: isHovered2 ? "#E6FFEE" : "#f9f9f9",
          borderRadius: "12px",
          padding: isMobileOrTablet ? "12px" : "24px",
          textAlign: "left",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={() => setIsHovered2(true)}
        onMouseLeave={() => setIsHovered2(false)}
      >
        <div style={{ display: "flex", marginBottom: isMobileOrTablet ? "8px" : "16px" }}>
          <img
            src={isHovered2 ? pcgreen : pc}
            alt="desktop"
            style={{ width: isMobileOrTablet ? "40px" : "50px", height: isMobileOrTablet ? "40px" : "50px" }}
          />
        </div>

        <div style={{ fontSize: isMobileOrTablet ? "11px" : "13px", color: "#808080", marginBottom: "4px" }}>
          Desktop
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "14px" : "18px",
            fontWeight: "600",
            color: isHovered2 ? "#22A45D" : "#1A1A1A",
            marginBottom: "8px",
            transition: "color 0.3s ease",
          }}
        >
          PC / MAC
        </div>

        <div
          style={{
            fontSize: isMobileOrTablet ? "11px" : "13px",
            color: "#555",
            marginBottom: isMobileOrTablet ? "8px" : "16px",
            lineHeight: "1.2",
          }}
        >
          Click on the download button to initiate the downloading process
        </div>

        <button
          style={{
            backgroundColor: "#22A45D",
            color: "#fff",
            border: "none",
            borderRadius: "25px",
            padding: "10px 24px",
            fontSize: "14px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <img
            src={load}
            alt="Download"
            style={{ width: "18px", height: "18px", objectFit: "contain" }}
          />
          Download
        </button>
      </div>
    </a>
  </div>
</div>
 
    {/* <div
                  style={{
                    fontFamily: "Epilogue",
                    lineHeight: "1.4",
                    padding: "clamp(30px, 5vw, 60px)",
                    marginTop: screenWidth <= 1024 ? "clamp(20px, 4vw, 40px)" : "0",
                  }}
                >
                  <div
                    style={{
                      maxWidth: "clamp(800px, 90vw, 1200px)",
                      margin: "0 auto",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          color: "#181835",
                          fontSize: "clamp(18px, 2.5vw, 22px)",
                          fontWeight: "bold",
                          paddingLeft: screenWidth <= 1440 ? "clamp(50px, 10vw, 110px)" : "clamp(100px, 12vw, 170px)",
                          alignSelf: "flex-start",
                        }}
                      >
                        Compliance of our company
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "clamp(10px, 2vw, 15px)",
                          marginTop: "clamp(15px, 2vw, 20px)",
                          flexWrap: "wrap",
                        }}
                      >
                        {complianceData.slice(0, 3).map((item, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              backgroundColor: "#F4F7FF",
                              width: "clamp(200px, 30vw, 270px)",
                              height: "clamp(35px, 5vw, 40px)",
                              padding: "clamp(4px, 1vw, 5px)",
                              borderRadius: "30px",
                              justifyContent: "space-between",
                              cursor: "pointer",
                              transition: "background-color 0.3s, transform 0.3s ease",
                              marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#EDF4FF";
                              e.currentTarget.style.transform = "scale(1.03)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = "#F4F7FF";
                              e.currentTarget.style.transform = "scale(1)";
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <div
                                style={{
                                  borderRadius: "50%",
                                  padding: "clamp(8px, 1.5vw, 10px)",
                                  marginRight: "clamp(8px, 1.5vw, 12px)",
                                }}
                              >
                                <img
                                  src={item.icon}
                                  alt={item.title}
                                  style={{
                                    width: "clamp(30px, 4vw, 40px)",
                                    height: "clamp(30px, 4vw, 40px)",
                                  }}
                                />
                              </div>
                              <span
                                style={{
                                  color: "#181835",
                                  fontSize: "clamp(10px, 1.5vw, 12px)",
                                  marginRight: "-10px",
                                }}
                              >
                                {item.title}
                              </span>
                            </div>
                            <img
                              src={riarr}
                              alt="Arrow"
                              style={{
                                width: "clamp(14px, 2vw, 18px)",
                                height: "clamp(14px, 2vw, 18px)",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "clamp(10px, 2vw, 15px)",
                        marginTop: "clamp(15px, 2vw, 20px)",
                        flexWrap: "wrap",
                        marginRight: screenWidth <= 1024 ? "clamp(5px, 2vw, 10px)" : "clamp(100px, 20vw, 290px)",
                      }}
                    >
                      {complianceData.slice(3, 5).map((item, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#F4F7FF",
                            width: "clamp(200px, 30vw, 270px)",
                            height: "clamp(35px, 5vw, 40px)",
                            padding: "clamp(4px, 1vw, 5px)",
                            borderRadius: "30px",
                            justifyContent: "space-between",
                            cursor: "pointer",
                            transition: "background-color 0.3s, transform 0.3s ease",
                            marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#EDF4FF";
                            e.currentTarget.style.transform = "scale(1.03)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "#F4F7FF";
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div
                              style={{
                                borderRadius: "50%",
                                padding: "clamp(8px, 1.5vw, 10px)",
                                marginRight: "clamp(8px, 1.5vw, 12px)",
                              }}
                            >
                              <img
                                src={item.icon}
                                alt={item.title}
                                style={{
                                  width: "clamp(30px, 4vw, 40px)",
                                  height: "clamp(30px, 4vw, 40px)",
                                }}
                              />
                            </div>
                            <span
                              style={{
                                color: "#181835",
                                fontSize: "clamp(10px, 1.5vw, 12px)",
                                marginRight: "-10px",
                              }}
                            >
                              {item.title}
                            </span>
                          </div>
                          <img
                            src={riarr}
                            alt="Arrow"
                            style={{
                              width: "clamp(14px, 2vw, 18px)",
                              height: "clamp(14px, 2vw, 18px)",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div> */}
 
     <div
                style={{
                  fontFamily: "Epilogue",
                  lineHeight: "1.4",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "-20px",
                  justifyContent: "center",
                  backgroundColor: "#2C8C53",
                  padding: "clamp(20px, 3vw, 40px) clamp(40px, 5vw, 90px)",
                  color: "#fff",
                }}
                className="newsletter-section"
              >
                <div
                  style={{
                    marginRight: "clamp(20px, 3vw, 40px)",
                    marginBottom: "clamp(16px, 2vw, 20px)",
                  }}
                >
                  <img
                    src={newsgreen}
                    alt="Newsletter"
                    style={{
                      width: "clamp(150px, 20vw, 200px)",
                      height: "clamp(120px, 15vw, 170px)",
                      animation: "floatImage 3s ease-in-out infinite",
                    }}
                  />
                </div>
        
                <style>
                  {`
              @keyframes floatImage {
                0% { transform: translateY(0); }
                50% { transform: translateY(-10px); }
                100% { transform: translateY(0); }
              }
        
              @media (max-width: 480px) {
                .newsletter-section {
                  flex-direction: column;
                  text-align: center;
                  padding: clamp(16px, 3vw, 24px) clamp(16px, 4vw, 24px);
                }
                .newsletter-section > div:first-child {
                  margin-right: 0;
                  margin-bottom: clamp(16px, 2vw, 20px);
                }
                .newsletter-section h2,
                .newsletter-section p,
                .newsletter-section > div > div,
                .newsletter-section > div > div:last-child {
                  margin-left: 0;
                }
                .newsletter-section .newsletter-input {
                  min-width: clamp(200px, 80vw, 260px);
                }
                .newsletter-section button {
                
                  display: block;
                }
              }
            `}
                </style>
        
                 <div className="newsletter-content">
          {/* Title and Paragraph */}
          <>
            <style>
              {`
      .newsletter-text {
        font-family: Epilogue;
        line-height: 1.4;
        font-size: 22px;
        margin-bottom: 10px;
        margin-left: 60px;
      }

      @media (max-width: 1024px) {
        .newsletter-text {
          font-size: 20px;
          margin-left: 50px;
        }
      }

      @media (max-width: 768px) {
        .newsletter-text {
          font-size: 18px;
          margin-left: 40px;
        }
      }

      @media (max-width: 480px) {
        .newsletter-text {
          font-size: 16px;
          margin-left: 30px;
        }
      }
    `}
            </style>

            <div className="newsletter-text">Subscribe to our Newsletter!</div>
          </>

          <>
            <style>
              {`
      .newsletter-description {
        font-size: 14px;
        margin-bottom: 20px;
        text-align: start;
        margin-left: 60px;
        max-width: 100%;
        box-sizing: border-box;
      }

      @media (max-width: 1024px) {
        .newsletter-description {
          font-size: 13px;
          margin-left: 50px;
        }
      }

      @media (max-width: 768px) {
        .newsletter-description {
          font-size: 12.5px;
          margin-left: 40px;
        }
      }

      @media (max-width: 480px) {
        .newsletter-description {
          font-size: 9px; /* reduced more for small screens */
          text-align: center;
      
        }
      }
    `}
            </style>

            <div className="newsletter-description">
              Stay updated with our latest news, offers, and insights! Subscribe{" "}
              <br />
              for exclusive updates delivered straight to your inbox.
            </div>
          </>

          
        <>
  <style>
    {`
      .input-wrapper {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: 0 auto 10px auto; /* center aligned */
        flex-wrap: nowrap;
      }

      .email-input {
        padding: 14px 16px 14px 48px;
        border-radius: 10px;
        border: 1px solid #9FCAFF;
        outline: none;
        background-color:#1C6539;
        color: #fff;
        flex: 1;
        width: 100%;
        box-sizing: border-box;
        font-size: 16px;
      }

      .email-icon {
        position: absolute;
        left: 16px;
        width: 20px;
        height: 20px;
      }

      /* Optional: Keep consistent appearance on all devices */
      @media (max-width: 480px) {
        .email-input {
          padding: 12px 12px 12px 44px;
          font-size: 14px;
        }
      }
    `}
  </style>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      justifyContent: "center",
    }}
  >
    <div className="input-wrapper">
      <img src={mail} alt="Email Icon" className="email-icon" />
      <input
        type="email"
        value={email}
        placeholder="sample@gmail.com"
        className="email-input"
        onChange={handleChange}
      />
    </div>
  </div>
</>


         
          <>
            <style>{`
        .captcha-container {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 10px auto !important;
          border-radius: 20px !important;    
          gap: 8px !important;
          flex-wrap: wrap !important;
        }
      .captcha-box {
  width: 60px !important;
  height: 40px !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important; /* Add this to clip canvas overflow */
}

#captchaCanvas {
  border-radius: 20px !important;
}
        .captcha-input {
          padding:10px 1px!important;
          border-radius:8px!important;
          border:1px solid #ccc!important;
          outline:none!important;
          min-width:120px!important;
          background:#1C6539!important;
          color:#fff!important;
        }
        .subscribe-button {
          padding:14px 30px!important;
          border-radius:12px!important;
          border:none!important;
          background:#fff!important;
          color:#1C6539!important;
          font-weight:bold!important;
          cursor:pointer!important;
          margin-bottom:0!important;
        }
        @media(max-width:1024px){ .captcha-container{margin-left:50px!important;} .captcha-input{min-width:110px!important;} }
        @media(max-width:768px ){ .captcha-container{margin-left:40px!important;} .captcha-input{min-width:100px!important;} }
        @media(max-width:480px ){ .captcha-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captcha-input{min-width:80px!important;font-size:14px!important;} }
      `}</style>

            <div className="captcha-container">
              <div className="captcha-box">
                <canvas
                  ref={canvasRef}
                  id="captchaCanvas"
                  width={60}
                  height={40}
                />
              </div>

              <button
                onClick={handleReload}
                style={{
                  background: "#1C6539",
                  color: "#fff",
                  border: "none",
                  padding: "8px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Your reload SVG icon here */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button>

              <input
                type="text"
                placeholder="Enter captcha"
                value={userCaptcha}
                onChange={(e) => setUserCaptcha(e.target.value)}
                className="captcha-input"
              />

              <button className="subscribe-button" onClick={handleSubscribe}>
                Subscribe
              </button>
            </div>
          </>

          {/* Note */}
          <div
            style={{
              fontSize: "12px",
              marginTop: "10px",
              color: "#fff",
              marginLeft:
                window.innerWidth <= 480
                  ? "20px"
                  : window.innerWidth <= 768
                  ? "40px"
                  : window.innerWidth <= 1024
                  ? "50px"
                  : "60px",
            }}
          >
            *Unsubscribe anytime. We don’t send any spam
          </div>
        </div>
              </div>
 
     <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    justifyContent: "space-between",
    padding: isMobile ? "20px 10px" : "40px",
    backgroundColor: "#fff",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "0 auto",
    boxSizing: "border-box",
  }}
>
  <div
    style={{
      maxWidth: isMobile ? "100%" : isTablet ? "50%" : "300px",
      marginBottom: "40px",
    }}
  >
    <Link to="/">
      <img
        src={logo}
        alt="Mawalog"
        style={{
          width: isMobile ? "150px" : "180px",
          height: "auto",
          display: "flex",
          justifyContent: "start",
          cursor: "pointer"  // shows it's clickable
        }}
      />
    </Link>
    <p
      style={{
        color: "#555",
        fontSize: isMobile ? "12px" : "14px",
        lineHeight: "1.6",
        textAlign: "start",
        marginBottom: isMobile ? "20px" : "100px",
      }}
    >
      At Mawalog, we believe in simplifying the complexities of supply chain
      management by offering an integrated platform that combines manufacturing,
      logistics, and warehouse solutions partner with optimized logistics and a
      global network.
    </p>
    <div
      style={{
        display: "flex",
        gap: "12px",
        marginTop: isMobile ? "0" : "-80px",
      }}
    >
      {[insta, face, youtube, link,twit].map((icon, index) => (
        <img
          key={index}
          src={icon}
          alt={`icon-${index}`}
          style={{
            width: isMobile ? "20px" : "24px",
            height: isMobile ? "20px" : "24px",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            transformOrigin: "center",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.4)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "scale(1)")
          }
          onClick={() => {
            if (icon === face)
              window.open("https://www.facebook.com/mawalogone/", "_blank");
            if (icon === youtube)
              window.open("https://www.youtube.com/@mawalogone", "_blank");
            if (icon === insta)
              window.open("https://www.instagram.com/mawalogone/", "_blank");
            if (icon === link)
              window.open(
                "https://www.linkedin.com/company/mawalogone/",
                "_blank"
              )
              if (icon === twit)
              window.open("https://x.com/mawalogone", "_blank");
          }}
        />
      ))}
    </div>
  </div>

  <div
  style={{
    display: "flex",
    gap: isMobile ? "20px" : isTablet ? "40px" : "60px",
    flexWrap: "wrap",
    justifyContent: isMobile ? "flex-start" : "space-between",
  }}
>
  <div>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
      }}
    >
      Know More
    </h4>
{["Opportunities", "Articles", "Our Story", "Help Center"].map(
  (item, index) => (
    <p
      key={index}
      style={{
        margin: "8px 0",
        color: "#555",
        cursor: "pointer",
        textAlign: "start",
        fontSize: isMobile ? "12px" : "14px",
        transition: "color 0.3s ease",
        paddingBottom: "2px",
      }}
      onClick={() => {
        switch (item) {
          case "Opportunities":
          case "Articles":
          case "Help Center":
            navigate("/coming");
            break;
          case "Our Story":
            navigate("/about");
            break;
        }
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#3B82F6";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#555";
      }}
    >
      {item}
    </p>
  )
)}

  </div>

 <div>
      <h4
        style={{
          fontSize: isMobile ? "12px" : "14px",
          fontWeight: "bold",
          marginRight: isMobile ? "0" : "20px",
        }}
      >
        Legal &amp; Policies
      </h4>

 {[
  "Terms and Conditions",
  "Privacy Policy",
  "Cookie Policy",
  "Copyright Policy",
].map((item, index) => (
  <p
    key={index}
    style={{
      margin: "8px 0",
      color: "#555",
      cursor: "pointer",
      textAlign: "start",
      fontSize: isMobile ? "12px" : "14px",
      transition: "color 0.3s ease",
      paddingBottom: "2px",
    }}
    onClick={() => {
      const targetId = `#${item.toLowerCase().replace(/\s+/g, "-")}`;
      const basePath =
        item === "Terms and Conditions"
          ? "/terms"
          : item === "Privacy Policy"
          ? "/policy"
          : item === "Cookie Policy"
          ? "/cookie"
          : item === "Copyright Policy"
          ? "/copyright"
          : "/";
      navigate(`${basePath}${targetId}`);
    }}
    onMouseEnter={(e) => (e.currentTarget.style.color = "#3B82F6")}
    onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
  >
    {item}
  </p>
))}

    </div>

</div>


  <div style={{ marginBottom: "40px" }}>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
        marginRight: isMobile ? "0" : "180px",
      }}
    >
      Contact us
    </h4>
    <a
      href="https://mail.google.com/mail/?view=cm&to=info@mawalog.com"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#004BA8",
        cursor: "pointer",
        fontSize: isMobile ? "12px" : "14px",
        textAlign: "start",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src={ee}
        alt="Email"
        style={{
          width: isMobile ? "12px" : "14px",
          height: isMobile ? "12px" : "14px",
          marginRight: "8px",
        }}
      />
      info@mawalog.com
    </a>
    {[
      { phone: "603-27700-311", country: "Malaysia" },
      { phone: "+971-50-1234567", country: "UAE" },
      { phone: "+44 7911 123456", country: "UK" },
      { phone: "+91-44-4856-3345", country: "India" },
    ].map((contact, index) => (
      <p
        key={index}
        style={{
          fontSize: isMobile ? "12px" : "14px",
          textAlign: "start",
        }}
      >
        <img
          src={phone}
          alt="Phone"
          style={{
            width: isMobile ? "12px" : "14px",
            height: isMobile ? "12px" : "14px",
            marginRight: "8px",
          }}
        />
        <a
          href={`tel:${contact.phone}`}
          style={{
            color: "#004BA8",
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          {contact.phone}
        </a>{" "}
        (<span style={{ color: "#000" }}>{contact.country}</span>)
      </p>
    ))}
  </div>

  <div
    className="flex flex-col items-center justify-center p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-purple-700 text-white max-w-sm mx-auto shadow-lg"
    style={{ marginBottom: "40px", position: "relative" }}
  >
    <div style={{ position: "relative", display: "inline-block" }}>
      <a
        href="https://app.mawalog.com/register"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={trial}
          alt="Illustration"
          style={{
            width: isMobile ? "180px" : isTablet ? "200px" : "210px",
            height: "auto",
            display: "block",
            cursor: "pointer",
          }}
        />
      </a>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(130deg, transparent 48%, rgba(255,255,255,0.4) 50%, transparent 52%)",
            animation: "shine 3s ease-in-out infinite",
          }}
        ></div>
      </div>
    </div>
    <style>
      {`
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}
    </style>
  </div>
</div>
       
       
               <div
                 style={{
                   fontFamily: "Epilogue",
                   lineHeight: "1.4",
                   textAlign: "center",
                   padding: isMobile ? "15px 0" : "20px 0",
                   borderTop: "1px solid #ddd",
                   fontSize: isMobile ? "12px" : "14px",
                   color: "#333",
                 }}
               >
                 Copyright © 2025. <strong>MAWALOG</strong>. All Rights Reserved
               </div>
    </div>
  );
};

export default Industries;
